<template>
	<div class="card-base advert-card__small d-flex flex-column p-4">
		<div class="d-flex justify-content-end" v-if="advert.is_logo">
			<advert-logo-component :advert="advert" class="m-0"/>
		</div>
		<div class="d-flex align-items-center" v-if="advert.is_thumbnail || advert.is_icons">
			<div class="advert-card__thumbnail" v-if="advert.is_thumbnail">
				<img :alt="advert.name" :src="advert.thumbnail" v-if="advert.thumbnail"/>
			</div>
			<!-- TODO: Ha jönn az sdkból adat akkor a dummyIcont cserélni kell a propertyvel -->
			<advert-icon-component v-if="advert.is_icons" :icons="advert.icons" :custom-class="{'ms-auto': advert.is_thumbnail}"/>
		</div>
		<div>
			<p class="advert-card__job-type">{{ advert.type }}</p>
			<h5 class="advert-card__name">
				<router-link :to="{path: advertLink}">
					{{ advert.name }}
				</router-link>
			</h5>
		</div>
		<div>
			<p class="advert-card__place">{{ isAdvertLocationGroup ? advert.place.map((place) => translate(place)).join(', ') : translate('advert-location') }}</p>
			<h5 class="advert-card__city">{{ advert.locations.join(', ') }}</h5>
		</div>
		<div v-if="deadlineStatus">
			<p class="advert-card__deadline-text">{{ translate("advert-application-deadline") }}</p>
			<h5 class="advert-card__deadline">{{ advert.deadline }}</h5>
		</div>
		<div class="advert-card__buttons d-flex justify-content-between">
			<button-unit
					@click-on-btn="advert.advert_state !== 'inactive' && apply(advert.index_id)"
					:options="{
					shape: ButtonUnitShape.ROUNDED,
					text: translate('advert-apply'),
					bgColor: ButtonColor,
					textColor: ButtonTextColor,
					disabled: advert.advert_state === 'inactive'
				}"
			/>
			<button-unit
					v-if="siteStore.site.advert_box.is_details_btn_to_small_advert_box"
					@click-on-btn="this.$router.push({path: advertLink})"
					:options="{
					shape: ButtonUnitShape.ROUNDED,
					text: translate('advert-details-button-text'),
					bgColor: ButtonDetailsColor,
					textColor: ButtonDetailsTextColor,
				}"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';
import {AdvertCardClass} from "../Interfaces/AdvertCardInterface";
import AdvertApplyMixin from "../../../Mixins/AdvertApplyMixin";
import {AdvertCardItemInterface} from "../Interfaces/AdvertCardItemInterface";
import {ButtonUnitShape} from "@WebApp/Components/Units/Interfaces/ButtonUnitShape";
import ButtonUnit from "../../../Components/Units/ButtonUnit.vue";
import {LayoutCssVariables} from "@WebApp/Utils/LayoutCssVariables";
import AdvertIconComponent from "@WebApp/Views/AdvertPageView/Components/AdvertIconComponent.vue";
import {useSiteCheckStore} from "@WebApp/Stores/SiteCheck/SiteCheck";
import AdvertLogoComponent from "@WebApp/Views/AdvertPageView/Components/AdvertLogoComponent.vue";

export default defineComponent({
	name: 'AdvertCardVerticalSmall',
	mixins: [AdvertApplyMixin],
	components: {AdvertLogoComponent, AdvertIconComponent, ButtonUnit},
	props: {
		advert: {
			type: Object as PropType<AdvertCardItemInterface>,
			default: new AdvertCardClass(),
			required: true,
		}
	},
	setup() {
		return {
			siteStore: useSiteCheckStore()
		}
	},
	computed: {
		advertLink(): string {
			return this.advertLocalizeLink(this.advert.slug, this.advert.index_id);
		},
		ButtonUnitShape() {
			return ButtonUnitShape;
		},
		ButtonColor() {
			return `var(--${LayoutCssVariables.page.profile})`;
		},
		ButtonTextColor() {
			return 'white';
		},
		ButtonDetailsColor() {
			return `var(--${LayoutCssVariables.header.buttonBgColor})`;
		},
		ButtonDetailsTextColor() {
			return `var(--${LayoutCssVariables.header.buttonTextColor})`;
		},
		deadlineStatus() {
			return this.siteStore.currentSite.deadline_status;
		},
		isAdvertLocationGroup() {
			return this.siteStore.currentSite.is_advert_location_group;
		}
	},

});
</script>

<style lang="scss" scoped>

</style>
